import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import '@luna-protocol/core/src/index.scss';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<App />);
